module.exports = __webpack_public_path__ + "media/images/illustration_7-3897765d8f454419c68fa8cc1f6062c9.png";